"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
const Creative_1 = require("../Creative");
class ModificationRequestDeliverable {
    constructor({ id, creative, attachedThumbnail, intent, createdAt, }) {
        this.toJSON = () => {
            const attacehdThumbnail = this.attachedThumbnail ? this.attachedThumbnail.toJSON() : this.attachedThumbnail;
            return {
                id: this.id,
                creative: this.creative.toJSON(),
                attachedThumbnail: attacehdThumbnail,
                intent: this.intent,
                createdAt: this.createdAt.toISO(),
            };
        };
        this.id = id;
        this.creative = creative;
        this.attachedThumbnail = attachedThumbnail;
        this.intent = intent;
        this.createdAt = createdAt;
    }
}
ModificationRequestDeliverable.fromJSON = (json) => {
    const { id, creative, attachedThumbnail, intent, createdAt } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof intent !== 'string')
        throw new Error('.intent must be a string');
    if (typeof createdAt !== 'string')
        throw new Error('.createdAt must be a string');
    const _attacehdThumbnail = attachedThumbnail ? Creative_1.default.fromJSON(attachedThumbnail) : null;
    return new ModificationRequestDeliverable({
        id,
        creative: Creative_1.default.fromJSON(creative),
        attachedThumbnail: _attacehdThumbnail,
        intent,
        createdAt: luxon_1.DateTime.fromISO(createdAt),
    });
};
exports.default = ModificationRequestDeliverable;
